<script>
import linkCard from './LinkQuestionCard'
import Store from '@/store/index.js'
import modalWindow from '@/components/ModalWindow'
import 'bulma/css/bulma.css'
import { getTeamsByTeamIds } from '@/api/FirebaseTeamWrapper.js'
import { getUserData } from '@/api/FirebaseUserWrapper.js'
import { removeUrl, getUrls, formatDate } from '@/api/Utilities.js'
import * as constant from '@/constant/constant.js'
require('../css/style.css')

export default {
  components: {
    linkCard,
    modalWindow
  },
  props: ['tree'],
  data () {
    return {
      isSolved: false,
      myImageUrl: '',
      issue: '',
      externalUrl: [],
      hasExternalUrl: false,
      teamName: '',
      title: constant.DEFAULT_DOMAIN_TITLE
    }
  },
  async created () {
    this.isSolved = this.tree.solved

    const userData = await getUserData(this.tree.userId)
    this.myImageUrl = userData.imageUrl
    // teamNameを取得
    const array = [this.tree.scope]
    const teams = await getTeamsByTeamIds(array)
    this.teamName = teams[0].teamName

    this.issue = removeUrl(this.tree.issue)
    this.externalUrl = getUrls(this.tree.issue)
    if (this.externalUrl.length > 0) { this.hasExternalUrl = true }
  },
  async updated () {
    this.isSolved = this.tree.solved
  },
  methods: {
    clickSetViewingPage () {
      Store.commit('setViewingPage', '')
    }
  },
  filters: {
    timestampToDate: function (ts) {
      return formatDate(ts.toDate(), 'MM/dd HH:mm')
    }
  }
}

</script>
<style scoped>
.card-wrapper {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  /*
  padding-bottom: 0.75rem;
  */
}
.card-content {
  padding-top: 0rem;
  padding-left: 1.0rem;
  padding-right: 1.0rem;
  padding-bottom: 0rem;
}
.card-header-title {
  padding: 0.25rem 0.75rem 0.25rem;
}
.card-header-title.is-left {
  justify-content: flex-end;
}
.card-footer-item {
  padding: 0.25rem;
}
.card-header {
  box-shadow: 0 1px 2px rgba(255, 255, 255, 0.1);
}
.has-text-gray{
  color: #A9A9A9 !important;
}
.has-text-blue{
  color: #191970 !important;
}
.is-size-8 {
  font-size: 0.5rem !important;
}
.foot {
  display: flex;
}
.foot-text {
  margin-top: 0.25rem;
}
.tags.has-addons .tag {
  margin-top: 0.25rem;
  margin-right: .5rem;
  font-size: 0.6rem
}
.add-padding {
  padding: 0.5rem 0.1rem;
}
</style>
<template>
  <!--div class="column is-half is-paddingless"-->
    <div class="card-wrapper" v-if="!this.tree.isDeleted">
      <div class="card">
        <header class="card-header">
          <div class="card-header-title has-text-blue">
            <p class="text is-size-5 has-text-weight-bold">{{title}}</p>
            <p class="text">
              &nbsp;
              <span class="icon is-small">
                <i class="fa-solid fa-key" aria-hidden="true"></i>
              </span>
              &nbsp;
            </p>
            <p class="text is-size-8">
              非公開: {{this.teamName}}
            </p>
          </div>
          <div class="card-header-title is-left">
            <div class="tags">
              <span class="tag is-link is-size-8" v-if="!this.isSolved">
                受付中
              </span>
              <span class="tag is-dark is-size-8" v-else>
                CLOSE
              </span>
            </div>
          </div>
        </header>

        <div class="card-content">
          <div class="media is-marginless">
            <div class="media-left">
              <router-link v-bind:to="{ path: '/profile/' + this.tree.userId }">
                <figure class="image is-48x48">
                  <img class="is-rounded" :src="this.myImageUrl">
                </figure>
              </router-link>
            </div>
            <div class="media-content">
              <p class="text has-text-gray has-text-left is-size-8">{{ this.tree.userName }}</p>
              <div class="columns is-mobile is-marginless">
                <router-link  class="column is-paddingless" v-bind:class="{'is-three-quarters' : hasExternalUrl}" v-bind:to="{ path: '/tree/' + tree.id}">
                  <div class="issue">
                    <p class="text has-text-left has-text-weight-bold is-size-7" v-text="this.issue"></p>
                  </div>
                </router-link>
                <div class="column has-text-right is-paddingless" v-if="hasExternalUrl">
                  <linkCard
                  :url = "externalUrl[0]"
                  />
                </div>
              </div>

              <p class="text has-text-left is-size-8" v-text="externalUrl[0]" />

              <div class="columns is-mobile is-marginless">
                <div class="column is-one-quarter is-size-7 has-text-left add-padding has-text-centered" v-if="tree.views">
                  {{this.tree.views}} views
                </div>
                <div class="column has-text-right add-padding">
                  <b>Q:{{this.tree.totalQuestions}}</b>
                  <time class="text is-size-8" datetime="2016-1-1">
                    &nbsp;-&nbsp;
                    {{ this.tree.updatedAt | timestampToDate }}
                  </time>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  <!--/div-->
</template>



// WEBPACK FOOTER //
// src/components/QuestionCard.vue